module.exports = {

  /**
   * Site default title
   */
  title: 'GO-HR',
}
